export default {
  showUserModal: false,
  displayTree: null,
  displayManagerId: null,
  showUserDetails: false,
  showOrgUpload: false,
  matches: null,
  search: ''
};
